export const TASKS = {
  TASKS: 'TASKS',
  TASKS_KANBAN: 'TASKS_KANBAN',
  TASKS_TASK_PRIORITY: 'TASKS_TASK_PRIORITY',
  TASKS_TASK_TYPES: 'TASKS_TASK_TYPES',
  TASKS_TASK_CATEGORIES: 'TASKS_TASK_CATEGORIES',
  TASKS_TASK_DETAILS: 'TASKS_TASK_DETAILS',
  TASKS_TASK_STATUSES: 'TASKS_TASK_STATUSES',
  TASKS_TASK_OPPORTUNITIES: 'TASKS_TASK_OPPORTUNITIES',
  TASKS_RESERVATION_DETAILS: 'TASKS_RESERVATION_DETAILS',
};
